import React from 'react';
import { Tree } from '../../../types/tree';
import styles from './M_TreeCard.module.css';
import cn from 'classnames';
import A_Button from '../../A_Atoms/A_Button/A_Button';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { PATHS } from '@/constants/paths';
import { useNavigate } from 'react-router-dom';
import { formatPrice } from '@/utils/formatters';

export default function M_TreeCard({ tree }: { tree: Tree }) {
  const navigate = useNavigate();
  const handleRedirectToTreePage = (treeId: string) => {
    navigate(`${PATHS.TREE}/${treeId}`);
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h4 className={styles.tree_name}>{tree.name}</h4>
        <div className={styles.tree_info_wrapper}>
          <div className={styles.tree_location_wrapper}>
            <div className={styles.tree_image_wrapper}>
              <img src={tree.image} alt={tree.name} />
            </div>
            <div className={styles.tree_map_wrapper}></div>
          </div>
          <div className={styles.tree_description_wrapper}>
            <Q_Icon.LocationIcon width={24} height={24} fill='none' />
            <span className={cn(styles.tree_location_text, 'text-p-2')}>
              {tree.location}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.button_wrapper}>
        <span className={cn(styles.tree_cost, 'text-button')}>
          {formatPrice(tree.cost)}
        </span>
        <A_Button
          variant='tertiary'
          size='large'
          fontSize='text-button'
          icon={<Q_Icon.PlantIcon width={24} height={24} fill='none' />}
          onClick={() => {
            handleRedirectToTreePage(tree.id);
          }}
        >
          Посадить дерево
        </A_Button>
      </div>
    </div>
  );
}
